const $ = require('jquery');
import LookupTable from "../../components/lookupTable/index";
import run from '../../utilities/run';
import {isPresent} from "../../utilities/general";
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import {SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT,SUCCESS_MODAL_TIMEOUT} from "../../constants";
import render from "../../utilities/render";
import {buildExport,prepareDataToSendController,isEdit,readSpecificObjectFromCurrentData,doAjax,readSpecificKeyFromSearchCriteria,alterSearchCriteriForController,pushFilterSessionCacheState,retriveCriteriaObjectByOperation,isNew,isDeleteView,isOnlyLookupDataUpdate} from "../../utilities/filtersutil";
import {rulesLookupFieldDropdown} from "./filter/rulesLookupFieldDropdown.js";
import {actionOptions} from "./filter/actionOptions.js";
const _ = require("underscore");
import {keyDefaultFalseOption} from '../../utilities/general';
import {handleCustomDropdownEvents} from "../../utilities/customBootstrapDropdowns";

let actionCellDropdownTemplate = require('../../components/lookupTable/html/utilRenderTemplates/actionCellDropdown.html');
let actionCellDropdownItemTemplate = require('../../components/lookupTable/html/utilRenderTemplates/actionCellDropdownItem.html');
let actionHeaderDropdownTemplate = require('../../components/lookupTable/html/utilRenderTemplates/actionHeaderDropdown.html');
let detailLinkTemplate = require('./html/detailLinkTemplate.html');
let actionList = actionOptions;

const targetSelector = "#lookup-collateral-rules";

run(targetSelector, ()=>{
	const entryElement = $(targetSelector);
    const dataTableComponentData =  entryElement.data("rules-data");

    const viewRulesDetailURL =  entryElement.data("view-details-url");
    const filterSearchUrl =  entryElement.data("filter-search-url");
    const activateUrl =  entryElement.data("activate-url");
    const inactivateUrl =  entryElement.data("inactivate-url");
    const updateRuleUrl = entryElement.data("update-url");
	const bulkActivateDeactivateRuleUrl =  entryElement.data("bulk-activate-deactivate-rule-url");

    const portletNamespace =  entryElement.data("portlet-namespace");
    const shouldCheckCache  =  entryElement.data("should-check-cache");

    const savedViews  =  entryElement.data("saved-views");
    const saveViewURL  =  entryElement.data("save-view-url");
    const deleteViewURL  =  entryElement.data("delete-view-url");

    let submitModalFlow = new SubmitModalFlow();
    submitModalFlow.init();

    const extraDetailForCacheFromServer  =  entryElement.data("extra-detail-for-cache-from-server");
    const criteriaObjectFromServer  =  entryElement.data("filter-criteria-from-server");

    let targetObject = "";
    let totalRecordCount = 0;
    let lookupFieldDropdown = rulesLookupFieldDropdown;

    let selectedRows = "";

    if(shouldCheckCache)
    {
		targetObject = retriveCriteriaObjectByOperation(criteriaObjectFromServer,"like");
	}

	if(_.has(dataTableComponentData, "page")) {
		totalRecordCount = dataTableComponentData.page.totalElements;
	}

    function createDetailLink(data, type, row) {
    	let newRender;

	    newRender = render(
	      detailLinkTemplate, {
	        id: row.cbrId,
	        name: row.cbrName,
	        url: viewRulesDetailURL
	      }
	    );
	    return newRender;
    }

	function renderStatusPill(data, type, row){
		let status =  data;
		if(status  === false) {
			return "<div class='q-pill q-block q-pill-blue-border q-marg-all-xs-at-md q-pill-table'>Inactive</div>";
		} else {
			return "<div class='q-pill q-block q-pill-blue q-marg-all-xs-at-md q-pill-table'>Active</div>";
		}
		return "";
	}

	function formateDate(createdDate, type, data) {
		if(createdDate != null && createdDate != ""){
		  var date = new Date(createdDate); //createdDate is long time format
		  var month = date.getMonth() + 1;
		  var today = new Date();
		  today.setHours(0, 0, 0, 0);
		  var oneDay = 24*60*60*1000;
		  var diffDays = Math.round(Math.abs((today.getTime() - date.getTime())/(oneDay)));
		  var friendlyText = "";
		  var datePillHTML  = ""
		  if(diffDays < 100){
		  	friendlyText = diffDays.toString() + ' Days Ago';
		  	datePillHTML = "<span class='q-pretty-pill-tag q-ppt-pad-md q-ppt-lighter-grey q-ppt-large-radius q-fs-xs q-marg-left-md'>"+  friendlyText +"</span>"
		  }
		  if(diffDays == 0){
		    friendlyText = 'Today';
		  	datePillHTML = "<span class='q-pretty-pill-tag q-ppt-pad-md q-ppt-lighter-grey q-ppt-large-radius q-fs-xs q-marg-left-md'>"+  friendlyText +"</span>"
		  }else if(diffDays== 1){
		    friendlyText ='Yesterday'
		  	datePillHTML = "<span class='q-pretty-pill-tag q-ppt-pad-md q-ppt-lighter-grey q-ppt-large-radius q-fs-xs q-marg-left-md'>"+  friendlyText +"</span>"
		  }
		  return (month.toString().length > 1 ? month : "0" + month) + "/" + date.getDate() + "/" + date.getFullYear() + datePillHTML;
		}else{
		  return "";
		}
	}

    var ruleLookup = new LookupTable({
	    // REQUIRED - Set a target element
	    target: $("#collateral-rules-table-wrapper"),
	    // REQUIRED - Set which data should be visible for mobile
	    mobileColumns: [
		    {
		      data: "cbrName",
		      title: "Rule",
		      render: createDetailLink
		    },
		    {
		      data: "cbrDescription",
		      title: "Rule Description"
		    },
		    {
		      data: "cbrActive",
		      title: "Status",
		      render: renderStatusPill
		    }
		],
	   // tableFilters: {
	   //    data: orderFilterData,
	   //  },
      tableSearch: false,
	    // REQUIRED: search input info
	    tableSearchInput: {
	      // Not required
	      // placeholder: 'Custom Search Text'
	      value: (targetObject != "" ? targetObject.value[0] : "")

	    },
	    // REQUIRED - THIS IS TEMPORARY, WILL BE DEPRECATED WHEN WE ENABLE SEARCH INPUT ONLY
	    tableSearchDropdown: {
		  selected: (targetObject == "" ? "" : targetObject.key),
	      columns: lookupFieldDropdown
	    },
	    // OPTIONAL: Set Saved View Array
   		savedViews: savedViews,
   		bulkSelect: true,
	    // REQUIRED - Data Table specific settings
	    dataTable: {
	      // use same settings you would if you were just calling a dataTable normally
	    data: dataTableComponentData.content,
	      // Not required, just to show you can
	    columnDefs: [{}],
	      // Not required, just to show you can
	    order: [
	       [6, 'desc'],
	    ],
	    columns: [
	        {
	          data: "cbrActive",
	          render : renderActionWrap,
	          orderable:false,
	          class: 'dtc-action-column',
	          title: "Actions",
            },
	        {
	          data: "cbrName",
	          title: "Rule",
	          render: createDetailLink,
	          class: 'dtc-min-width-md'
	        },
	        {
	          data: "cbrDescription",
	          title: "Rule Description",
   			  class: 'dtc-min-width-md'

	        },
   	        {
	          data: "cbrActive",
	          title: "Status",
	          render: renderStatusPill,
	          class: 'dtc-min-width-md'
	        },
	        {
	          data: "cbrEffectiveEndDate",
	          title: "Effective Until",
	         class: 'dtc-min-width-sm'
	        },
	        {
	          data: "cbrCreatedDate",
	          title: "Created Date",
	          render: formateDate,
	         class: 'dtc-min-width-sm'
	        }
	      ]
	    },
	   //  tableColumnModal: {
      	//	data: ruleLookupColumnsPopup
    	//},
	    paginationData:dataTableComponentData.page,
	    filterModal: {
	      // REQUIRED: Sets title of modal
	      title: "Filter Collateral Rules",
	      // REQUIRED: Sets unique part of subtitle string.
	      tableType: "collateral"
	    },
	 	onBulkSelectChange: function() {
		    selectedRows = ruleLookup.getBulkSelectedData();
    	    $("th.dtc-action-column").html(renderActionHeaderWrap());
		    if (selectedRows.length >= 2) {
				$(".action-header-btn .base-btn").removeClass('disabled');
			}else{
			    $(".action-header-btn .base-btn").addClass('disabled');
			};
		},
	    onFetch: function() {
	      let currentData = ruleLookup.generateData();
	      ruleLookup.showLoadingOverlay();

       	  //Withing lookup screen onFetch fun. can be called for different level of actions - like New view , Edit view, Delete view and Search, remove pills
       	  if(isOnlyLookupDataUpdate(currentData)){
       	  	setTimeout(() => {
				doAjax({url: filterSearchUrl, success: filterSuccessFun, error: errorFun,data:prepareDataToSendController(currentData)});
	      	},SUCCESS_MODAL_TIMEOUT);
		   }else if(isNew(currentData)){
       	  	 setTimeout(() => {
	    		doAjax({url: saveViewURL, success: savedViewSuccess, error: errorFun, data:prepareDataToSendController(currentData)});
	      	 },SUCCESS_MODAL_TIMEOUT);
       	   }else if(isEdit(currentData)){
       	  	 setTimeout(() => {
	    		doAjax({url: saveViewURL, success: savedEditViewSuccess, error: errorFun, data:prepareDataToSendController(currentData)});
	      	 },SUCCESS_MODAL_TIMEOUT);
       	   }else if(isDeleteView(currentData)){
       	  	 setTimeout(() => {
	    		doAjax({url: deleteViewURL, success: delteViewScussFun, error: errorFun, data:prepareDataToSendController(currentData)});
	      	 },SUCCESS_MODAL_TIMEOUT);
       	   }
		}
    });

	function filterSuccessFun(data){
		let rules = data.content;
		let page = data.page;
		ruleLookup.setNewData(rules);
		ruleLookup.setPaginationData(page)
		pushFilterSessionCacheState();
		totalRecordCount = page.totalElements;
		ruleLookup.hideLoadingOverlay();
		//$(".data-table-component").DataTable().columns('.status-column').visible( false );
	}

	function savedViewSuccess(data){
	    let rules = data.lookupRuleJSON.content;
	    let page = data.lookupRuleJSON.page;
	    ruleLookup.setNewData(rules);
	    ruleLookup.setPaginationData(page);
	    ruleLookup.setNewSavedViewData(data.savedView, "newSavedView");
	  	pushFilterSessionCacheState();
	  	totalRecordCount = page.totalElements;
	    ruleLookup.hideLoadingOverlay();
	}


	function savedEditViewSuccess(data){
	    let rules = data.lookupRuleJSON.content;
	    let page = data.lookupRuleJSON.page;
	    ruleLookup.setNewData(rules);
	    ruleLookup.setPaginationData(page);
	    ruleLookup.setNewSavedViewData(data.savedView, data.savedView.target);
	  	pushFilterSessionCacheState();
	  	totalRecordCount = page.totalElements;
	    ruleLookup.hideLoadingOverlay();
	}


	function delteViewScussFun(data){
		let rules = data.lookupRuleJSON.content;
	    let page = data.lookupRuleJSON.page;
		ruleLookup.removeSavedView(data.target);
		ruleLookup.setNewData(rules);
	    ruleLookup.setPaginationData(page);
	    totalRecordCount = page.totalElements;
		ruleLookup.hideLoadingOverlay();
	}

	function errorFun(data){
   	    ruleLookup.hideLoadingOverlay();
	}

	ruleLookup.init();

	//const ordersDataTableObj = $("#lookup-order-wrapper .data-table-component").dataTable();
	function renderActionWrap(data, type, row, meta) {
	    let newRender;
	    let statusTarget = actionList["actions"];
	    newRender = render(
	      actionCellDropdownTemplate, {
	        list: renderActionCellList(statusTarget,data,row),
	        index: meta.row
	      }
	    );
	    return newRender;
    };

    function renderActionHeaderWrap() {
  	    let statusTarget = actionList['all'];
	    let newRender;
	    let data = "";
	    let row = "";
	    newRender = render(
	      actionHeaderDropdownTemplate, {
	        list: renderActionCellList(statusTarget,data,row)
	      }
	    );
	    return newRender;
    };

    function renderActionCellList(list,data,row) {
	    let renderedList;
	    renderedList = _(list).map((item)=>{
	      return render(
	        actionCellDropdownItemTemplate, {
	          icon: item.icon,
	          title: item.title,
	          cls: item.cls,
	          disabled:checkDisableForGivenAction(data,row,item.title)
	        }
	      )
   		 });
	    return renderedList.join('');
    };

	function checkDisableForGivenAction(data,row,actionName) {
	 	if(isRowLevelActionCheck(data)){
	    	return callBusinessLogicToDisableAction(data,row,actionName);
	    }else{
	      	let isTrue = false;
	    	_(selectedRows).map((item)=>{
	      		if(callBusinessLogicToDisableAction(item.data.cbrActive,item.data,actionName)){
	    			if (!isTrue){
	    				isTrue = true;
	    			}
	    		}
	        });
	    	return isTrue;
		}
	};

	function isRowLevelActionCheck(data) {
		return isPresent(data);
	}

	// Note this method will return true if we want to disable action, else return false if we want to enable
	function callBusinessLogicToDisableAction(status,row,actionName) {
		if (isPresent(status)) {
			if(actionName === "Deactivate Rule") {
				if(row.cbrActive === true){
					return false;
				} else {
					return true;
				}
			} else  if(actionName === "Activate Rule") {
				if(row.cbrActive === false){
					if(moment().isAfter(row.cbrEffectiveEndDate)){
						return true;	
					}else{
						return false;
					}
					
				} else {
					return true;
				}
			} else {
				return false;
			}
		}
	}

    function shallAllowClick(currentObj){
   		return 	!($(currentObj).hasClass("disabled"));
    }

	$('body').on('click', '.edit-rule, .activate-rule, .inactivate-rule', function(e) {
		e.preventDefault();
		if(shallAllowClick(this)) {
			// Since the menu ends up in the body when this lookup is happening, have to carry the index of the parent dropdown
			let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
			// Get the row based on the parent...
			let parent = $(".dropdown-parent-" + pIndex).parents('tr');
			// Get the row data
			let row = $(".data-table-component").dataTable().api().row(parent);

			if($(this).hasClass('edit-rule')) {
				processEditRule(row);
			} else if($(this).hasClass('activate-rule')) {
				processActivateRule(row);
			} else if($(this).hasClass('inactivate-rule')) {
				processInactivateRule(row);
			}
		}
	});

	function processEditRule(row) {
		location.href = updateRuleUrl + "&cbrId=" + row.data().cbrId;
	}

	function processActivateRule(row) {
		const submitModal = new SubmitModalFlow({
          confirmModalTitle: 'Activate',
          confirmModalBody: '<div class="q-pad-all-xl">Are you sure you want to activate this rule?</div>',
          confirmModalBtnText: 'Activate Rule',
          onConfirmClick: function(){
            submitModal.showLoadingModal();
            let data = row.data();
            activateRule(row, data);

            function activateRule(row, rule){
              $.ajax({
                url: activateUrl,
                type: 'POST',
                dataType: 'JSON',
                data: {
                  cbrId : rule.cbrId
                },
                success: function(data){
                if(data.response == "success") {
                    let d = row.data();
                    d.cbrActive=data.cbrActive;
                    d.cbrEffectiveEndDate=$.trim(data.cbrEffectiveEndDate);
                    d.cbrId=$.trim(data.cbrId);
                    row.data(d).draw();
                    submitModal.showSuccessModal();
                    setTimeout(function() {
                    	submitModal.hideAllModals();
                    }, window.constants.SUCCESS_MODAL_TIMEOUT);
                    }else{
                      submitModal.showFailureModal();
                    }
                },
                error: function(data){
                  submitModal.hideAllModals();
                }
              });
            };
          }
        });
        submitModal.init();
        submitModal.showConfirmModal();
	}

	function processInactivateRule(row) {
		const submitModal = new SubmitModalFlow({
          confirmModalTitle: 'Deactivate',
          confirmModalBody: '<div class="q-pad-all-xl">Are you sure you want to inactivate this rule?</div>',
          confirmModalBtnText: 'Deactivate Rule',
          onConfirmClick: function(){
            submitModal.showLoadingModal();
            let data = row.data();
            inactivateRule(row, data);

            function inactivateRule(row, rule){
              $.ajax({
                url: inactivateUrl,
                type: 'POST',
                dataType: 'JSON',
                data: {
                  cbrId : rule.cbrId
                },
                success: function(data){
                if(data.response == "success") {
                    let d = row.data();
                    d.cbrActive=data.cbrActive;
                    d.cbrEffectiveEndDate=$.trim(data.cbrEffectiveEndDate);
                    d.cbrId=$.trim(data.cbrId);
                    row.data(d).draw();
                    submitModal.showSuccessModal();
                    setTimeout(function() {
                    	submitModal.hideAllModals();
                    }, window.constants.SUCCESS_MODAL_TIMEOUT);
                    }else{
                      submitModal.showFailureModal();
                    }
                },
                error: function(data){
                  submitModal.hideAllModals();
                }
              });
            };
          }
        });
        submitModal.init();
        submitModal.showConfirmModal();
    }

	$('body').on( 'click', '.bulk-activate-rule', function (e) {
		e.preventDefault();
		if(shallAllowClick(this)){
			var submitModalFlow = new SubmitModalFlow({
				confirmModalTitle: 'Activate Rules',
				confirmModalBody: '<div class="q-pad-all-xl">Once these products are activated, orders can be fulfilled with these products and inbound shipments can contain these products.</div>',
				confirmModalBtnText: 'Activate Rules',
				onConfirmClick: function() {
					submitModalFlow.showLoadingModal();
					activateRules();
					function activateRules() {
						$.ajax({
							url: bulkActivateDeactivateRuleUrl,
							type: 'POST',
							dataType: 'JSON',
							data: {
								[`cbrIds`]: getAllSelectedCbrIds(),
								[`action`]: 'Activate'
							},
							success: function(data){
								if(data.response == "success") {
									_(selectedRows).map((item)=>{
										let currentRow =  $(".data-table-component").DataTable().row(item.rowIndex)
										var d = currentRow.data();
										d.cbrActive = true;
										currentRow.data(d).draw();
									});
									ruleLookup.uncheckAllSelected();
									submitModalFlow.showSuccessModal();
									setTimeout(function() {
										submitModalFlow.hideAllModals();
									}, window.constants.SUCCESS_MODAL_TIMEOUT);
								}else{
									submitModalFlow.showFailureModal();
								}
							},
							error: function(data){
								submitModalFlow.hideAllModals();
							}
						});
					}
				}
			});
			submitModalFlow.init();
			submitModalFlow.showConfirmModal();
		}
	});

	$('body').on( 'click', '.bulk-deactivate-rule', function (e) {
    e.preventDefault();
    if(shallAllowClick(this)){
      var submitModalFlow = new SubmitModalFlow({
        confirmModalTitle: 'Deactivate Rules',
        confirmModalBody: '<div class="q-pad-all-xl">Once these products are deactivated, orders containing these products won’t be fulfilled and these products cannot be added to inbound shipments.</div>',
        confirmModalBtnText: 'Deactivate Rules',
        onConfirmClick: function() {
          submitModalFlow.showLoadingModal();
          deactivateRules();
          function deactivateRules() {
            $.ajax({
              url: bulkActivateDeactivateRuleUrl,
              type: 'POST',
              dataType: 'JSON',
              data: {
                [`cbrIds`]: getAllSelectedCbrIds(),
								[`action`]: 'Deactivate'
              },
              success: function(data){
                if(data.response == "success") {
                  _(selectedRows).map((item)=>{
       	      	    let currentRow =  $(".data-table-component").DataTable().row(item.rowIndex)
       	     	      var d = currentRow.data();
                    d.cbrActive = false;
       		          currentRow.data(d).draw();
       	    	    });
                  ruleLookup.uncheckAllSelected();
                  submitModalFlow.showSuccessModal();
                  setTimeout(function() {
                    submitModalFlow.hideAllModals();
                  }, window.constants.SUCCESS_MODAL_TIMEOUT);
                }else{
                  submitModalFlow.showFailureModal();
                }
              },
              error: function(data){
                submitModalFlow.hideAllModals();
              }
            });
          }
        }
      });
      submitModalFlow.init();
      submitModalFlow.showConfirmModal();
    }
  });

	function getAllSelectedCbrIds(){
		var cbrIds = new Array();
		_(selectedRows).map((item)=>{
			cbrIds.push(item.data.cbrId);
		 });
		return cbrIds;
	}

	// Allow custom dropdowns to work (based on class 'overflow-dropdown'), check the template for more information...
  	handleCustomDropdownEvents();

    $("th.dtc-action-column").html(renderActionHeaderWrap());
});



// WEBPACK FOOTER //
// ./src/pages/collateralRules/lookup.js